export default __webpack_public_path__ + "static/media/apjabdulkalam.4472456676c429bc64e53eb734a0a50f.png";